// Smokey & Creamy — site content (single source of truth)

export const BRAND = {
  name: "Smokey & Creamy",
  tagline: "Winnipeg's 100% Halal burger, philly & taco house.",
  phoneDisplay: "(431) 335-9900",
  phoneHref: "tel:+14313359900",
  addressLine1: "2 – 120 Lowson Crescent",
  addressLine2: "Winnipeg, Manitoba, Canada",
  hours: "Open 7 days · Mon–Tue 5 PM–12 AM · Wed–Sun 5 PM–2 AM",
  hoursList: [
    ["Mon – Tue", "5:00 PM – 12:00 AM"],
    ["Wed – Sun", "5:00 PM – 2:00 AM"],
  ],
  website: "https://smokeyandcreamy.ca/",
  kicker: "Cuz Itzz Smokeyy & Creamyyy!",
  description:
    "Located at 120 Lowson Cres in Winnipeg, Smokey & Creamy is redefining takeout and delivery comfort food with a 100% Halal menu. Operating as a dedicated ghost kitchen, we bring together bold Canadian and Mexican fusion flavours — expertly balancing fire-kissed smoky spices with rich, creamy comfort.",
  descriptionShort:
    "Winnipeg's 100% Halal ghost kitchen — bold Canadian & Mexican fusion, where fire-kissed smoky spice meets rich, creamy comfort.",
  logo: "/logo-emblem.png",
  mapsEmbed:
    "https://www.google.com/maps?q=Smokey+%26+Creamy+120+Lowson+Cres+Winnipeg+Manitoba&output=embed",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=Smokey+%26+Creamy+120+Lowson+Cres+Winnipeg",
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/smokeycreamy?igsh=NjBnemVxc2k2c3h6",
  facebook: "https://www.facebook.com/share/187VdtBaNt/?mibextid=wwXIfr",
  tiktok: "https://www.tiktok.com/@smokeycreamy?lang=en",
  googleReview: "https://g.page/r/CacNQwMurjTVEAE/review",
};

// Delivery partners
export const ORDER = {
  ubereats:
    "https://www.ubereats.com/ca/store/smokey-%26-creamy-120-lowson-cres/yLOAcjSYQFaLYzys3YJLbw",
  doordash:
    "https://www.doordash.com/store/smokey-&-creamy-winnipeg-41911113/102629347/",
  skipthedishes: "https://www.skipthedishes.com/smokey-and-creamy-lowson-cres",
  fantuan: "https://www.fantuanorder.com/store/smokey-creamy/ca-1369998989",
};

const CDN = "https://static.prod-images.emergentagent.com/jobs/8641b2d7-57ad-4591-96a9-7a5ab8142009/images";
const REAL = "https://customer-assets-eiarnc6j.emergentagent.net/job_smokey-creamy-new/artifacts";

export const IMAGES = {
  // HD generated (from real dish references)
  meatStack: `${CDN}/2c847598fce3173bc0afcc5fca6ac82bd19e00c2c313b31a0554c978d17984de.jpeg`,
  creamyTuscan: `${CDN}/6cd363199d0834ce16506a744a5901148d0564657c95acaab0728fab4b97ec86.jpeg`,
  quesadilla: `${CDN}/5e63282c756dd052521a77c835930b383196e822bc25e4c99a904516b2cbe146.jpeg`,
  poutine: `${CDN}/9b657d88030f160bdd56e1bb99fad9ef1aac54a82f0cab1e6a4bb721e25a802e.jpeg`,
  fajitaPasta: `${CDN}/49ed3b76225f955a116ff6babd9bb3988a25a98c69c2bf2655d83c2aba4d866c.jpeg`,
  alpineBurger: `${CDN}/0b479d864ab9bb2d5be6947fa7cf0e081632d2cf637079818978e206a9a42cc0.jpeg`,
  wings: `${CDN}/d78778c8d755628a16e1d872c64b70d814b514dcd6ef0d59926c559a7e5f3080.jpeg`,
  fireySticks: `${CDN}/585cdb8dc2e333f513a0220ef09fa20d83cd014bd4c41701b51c188a7e7dfdfe.jpeg`,
  // Real clean product photos
  jalapenoBurger: `${REAL}/8lgjdfta_IMG_20260723_204359.png`,
  phillyMelt: `${REAL}/rw2iidwd_IMG_20260722_171552.png`,
  tresTacos: `${REAL}/161jj0l5_IMG_20260729_195641.png`,
  tenders: `${REAL}/s70s2fvh_IMG_20260722_171355.png`,
  guacamole: `${REAL}/3eks5xcq_IMG_20260730_202555.png`,
  bakedPasta: `${REAL}/qez93hi5_2100%20width-4.webp`,
  madFuego: `${REAL}/b90fkgaa_1000000259.png`,
  birriaPoutine: `${REAL}/r1w67nb3_1000005517.png`,
  phillyPoutine: `${REAL}/1sr0lxwr_1000000281.png`,
  classicOG: `${REAL}/xw3uxff8_1788654632223.png`,
  quesaBirria: `${CDN}/29d9ec8f873cf2c045898c3ed7ffdb1aec6edd8282f8e31475ed20b81a4581b1.jpeg`,
  quesaChicken: `${CDN}/9ff73f065e0affbe03de50a9f2038946d3f075d897d9a70742a28a244385758d.jpeg`,
  chickenTacos: `${REAL}/byt87eqw_IMG_20260820_231209.png`,
  coleslawChicken: `${REAL}/xtqrt0w7_1000005513.png`,
};

// Bento highlights — our top 5 sellers
export const HIGHLIGHTS = [
  {
    id: "philly-melt",
    name: "Philly Melt 204",
    tag: "Top Seller",
    desc: "Seared shaved steak, roasted peppers, onions & mushrooms melted under mozzarella on a toasted baguette.",
    price: "$16.99",
    img: IMAGES.phillyMelt,
    span: "lg:col-span-8 lg:row-span-2",
  },
  {
    id: "tres-tacos",
    name: "Birria Tacos",
    tag: "Crispy · Cheesy",
    desc: "Grilled tacos loaded with roasted beef & melted cheese, served with complimentary consommé for dipping.",
    price: "from $14.99",
    img: IMAGES.tresTacos,
    span: "lg:col-span-4",
  },
  {
    id: "quesadilla",
    name: "Loaded Quesa Birria",
    tag: "Fully Loaded",
    desc: "Grilled tortilla stuffed with slow-braised birria beef & melted cheese. Salsa & sour cream on the side.",
    price: "$16.49",
    img: IMAGES.quesaBirria,
    span: "lg:col-span-4",
  },
  {
    id: "alpine-burger",
    name: "Alpine Swiss Burger",
    tag: "Aged Swiss",
    desc: "Grilled beef patties, aged Swiss & sautéed mushrooms on a toasted brioche bun.",
    price: "$16.99",
    img: IMAGES.alpineBurger,
    span: "lg:col-span-4",
  },
  {
    id: "creamy-tuscan",
    name: "Creamy Tuscan Pasta",
    tag: "Fan Favourite",
    desc: "Roasted garlic cream, sun-dried tomatoes & spinach, finished with parmesan. Chicken or Philly.",
    price: "$16.99",
    img: IMAGES.creamyTuscan,
    span: "lg:col-span-4",
  },
];

export const MENU = [
  {
    section: "Combo Specials",
    items: [
      { name: "Heat Combo", desc: "1 Smashed Jalapeño Burger + 1 Mad Fuego Pasta, plus a choice of pop. Built for those who like it fiery.", prices: [["Meal", "33.99"]], badge: "Combo" },
      { name: "Couple Combo", desc: "2 Smoked Fajita Chicken Pastas + 1 Golden Crunch Tenders (5 pcs) & a fry basket, plus a choice of any 2 pops.", prices: [["Meal", "42.99"]], badge: "Combo" },
      { name: "Family Combo", desc: "8 pcs Birria Tacos + 8 pcs Chicken Tacos + 1 Prairie Gold Poutine. Enough to feed the whole crew.", prices: [["Meal", "62.99"]], badge: "Combo" },
    ],
    note: "Combos are already a deal — perfect for sharing.",
  },
  {
    section: "Signature Specials",
    items: [
      { name: "Birria Tacos", desc: "Grilled tacos filled with roasted beef & melted cheese. Served with lime & complimentary consommé for dipping.", prices: [["3 Pcs", "14.99"], ["5 Pcs", "22.99"], ["8 Pcs", "29.99"]], img: IMAGES.tresTacos },
      { name: "Chicken Tacos", desc: "Crispy yellow-corn tortillas stuffed with our special seasoned chicken, melted cheese, onions & cilantro, topped with fresh diced tomato. Served with our house special green sauce.", prices: [["3 Pcs", "14.50"], ["5 Pcs", "20.99"], ["8 Pcs", "27.99"]], badge: "New", img: IMAGES.chickenTacos },
      { name: "Loaded Quesa Birria (Beef)", desc: "Grilled tortilla stuffed with slow-braised birria beef & melted cheese. Served with salsa, sour cream & a side of fries/salad.", prices: [["Reg", "16.49"]], badge: "New", img: IMAGES.quesaBirria },
      { name: "Loaded Quesadilla (Chicken)", desc: "Grilled tortilla stuffed with seasoned chicken, melted cheese & sautéed veg. Served with salsa, sour cream & a side of fries/salad.", prices: [["Reg", "15.49"]], badge: "New", img: IMAGES.quesaChicken },
    ],
    note: "Every Birria Tacos order comes with complimentary consommé. Add our special green sauce (2oz) for $2.99.",
  },
  {
    section: "Appetizers",
    items: [
      { name: "Golden Crunch Tenders", desc: "Hand-breaded chicken tenders fried golden, finished with smoky house seasoning.", prices: [["Each", "1.79"], ["5 Pcs", "8.99"]], img: IMAGES.tenders },
      { name: "Firey Sticks", desc: "House-cut fries in our signature smoky spice blend, topped with a parmesan drizzle.", prices: [["Reg", "7.99"]], img: IMAGES.fireySticks },
      { name: "Prairie Gold Poutine", desc: "Golden fries topped with fresh cheese curds, loaded cheese & rich house gravy.", prices: [["Reg", "10.99"], ["XL", "14.99"]], img: IMAGES.poutine },
      { name: "Philly Steak Poutine", desc: "Loaded poutine crowned with seared shaved Philly steak, onions & peppers.", prices: [["Reg", "14.99"]], badge: "New", img: IMAGES.phillyPoutine },
      { name: "Birria Poutine", desc: "Golden fries, cheese curds & gravy loaded with slow-braised birria beef.", prices: [["Reg", "15.99"]], badge: "New", img: IMAGES.birriaPoutine },
    ],
    note: "Add-ons: Add Chicken $3.99 · Add Philly $4.99",
  },
  {
    section: "Pasta",
    items: [
      { name: "Smoked Fajita Chicken", desc: "Grilled smoky chicken, fire-roasted peppers & onions in a creamy garlic fajita sauce over pasta.", prices: [["Reg", "15.99"]], img: IMAGES.fajitaPasta },
      { name: "Creamy Tuscan", desc: "Roasted garlic cream, sun-dried tomatoes & spinach, finished with parmesan. Chicken or Philly.", prices: [["Reg", "16.99"]], img: IMAGES.creamyTuscan },
      { name: "Cheezy Bakeblust Pasta", desc: "Oven-baked pasta smothered in a molten blend of cheeses with our signature smoky sauce.", prices: [["Reg", "16.99"]], badge: "New", img: IMAGES.bakedPasta },
      { name: "Mad Fuego Pasta", desc: "Penne tossed in a bold, beefy sauce with a fiery jalapeño kick and our secret house seasonings. Rich, savoury and unapologetically spicy — served with a slice of garlic bread.", prices: [["Reg", "16.99"]], badge: "New", img: IMAGES.madFuego },
    ],
    note: "A slice of garlic toast is complimentary with all pasta.",
  },
  {
    section: "Burgers",
    items: [
      { name: "Classic OG Cheez", desc: "Dual beef patties, melted cheddar, fresh toppings & our signature house sauce.", prices: [["Reg", "12.99"], ["Combo", "15.99"]], img: IMAGES.classicOG },
      { name: "Alpine Swiss Burger", desc: "Grilled beef patties, aged Swiss & sautéed mushrooms on a brioche bun.", prices: [["Reg", "16.99"], ["Combo", "20.99"]], img: IMAGES.alpineBurger },
      { name: "Smoky Meat Stack", desc: "Braised pulled beef over Philly steak, melted cheese, crispy onions & house sauce on brioche.", prices: [["Reg", "18.99"]], img: IMAGES.meatStack },
      { name: "Philly Melt 204", desc: "Seared shaved steak, roasted peppers, onions & mushrooms with mozzarella on a toasted baguette.", prices: [["Reg", "16.99"], ["Combo", "20.99"]], img: IMAGES.phillyMelt },
      { name: "Smashed Jalapeño Burger", desc: "Smashed patties, cheddar, sautéed onions, jalapeños, burger sauce & sweet chili on brioche.", prices: [["Reg", "15.99"], ["Combo", "19.99"]], badge: "New", img: IMAGES.jalapenoBurger },
      { name: "Coleslaw Chicken Burger", desc: "Seasoned breaded crispy chicken, melted cheddar, our house-made coleslaw, pickles & burger sauce on a premium sesame bun.", prices: [["Reg", "14.49"]], badge: "New", img: IMAGES.coleslawChicken },
    ],
    note: "Combo = Poutine/Salad + Pop. Regular Burgers & Philly Melt 204 come with complimentary fries.",
  },
  {
    section: "Salads",
    items: [
      { name: "Caesar Classico", desc: "Crisp romaine, house-made creamy Caesar dressing, parmesan & golden croutons.", prices: [["Reg", "11.99"]] },
      { name: "Greek Salad", desc: "Cucumbers, tomatoes, red onions, olives, feta & Greek dressing with olive oil.", prices: [["Reg", "11.99"], ["XL", "14.99"]] },
      { name: "Garden Salad", desc: "A fresh mix of greens & vegetables with Italian dressing.", prices: [["Reg", "10.99"]] },
    ],
    note: "Add-ons: Add Chicken $3.99 · Add Philly $4.99",
  },
  {
    section: "Dips & Beverages",
    items: [
      { name: "House Dips", desc: "204 Honey Dill · Hot Sauce · Honey Garlic · Smoky BBQ · Hot Honey · Sweet Chilli (2oz).", prices: [["2oz", "1.99"]] },
      { name: "Smokey Sauce", desc: "The one everyone talks about (2oz).", prices: [["2oz", "2.99"]] },
      { name: "Special Green Sauce", desc: "Our signature house green sauce — the perfect kick for your tacos (2oz).", prices: [["2oz", "2.99"]] },
      { name: "Consommé", desc: "Rich, slow-braised birria broth — perfect for dipping (4oz).", prices: [["4oz", "3.99"]] },
      { name: "Guacamole", desc: "House-made, fresh daily (4oz).", prices: [["4oz", "2.99"]], img: IMAGES.guacamole },
      { name: "Fountain & Cans", desc: "Coke · Pepsi · Canada Dry · 7UP · Fanta · Brisk · Root Beer · Jarritos.", prices: [["from", "1.99"]] },
    ],
  },
];

// Gallery — HD real & beautified dish photography
export const GALLERY = [
  { src: IMAGES.jalapenoBurger, label: "Smashed Jalapeño Burger", w: "tall" },
  { src: IMAGES.phillyMelt, label: "Philly Melt 204" },
  { src: IMAGES.tresTacos, label: "Birria Tacos" },
  { src: IMAGES.chickenTacos, label: "Chicken Tacos" },
  { src: IMAGES.meatStack, label: "Smoky Meat Stack" },
  { src: IMAGES.creamyTuscan, label: "Creamy Tuscan" },
  { src: IMAGES.poutine, label: "Prairie Gold Poutine" },
  { src: IMAGES.quesaBirria, label: "Loaded Quesa Birria" },
  { src: IMAGES.quesaChicken, label: "Loaded Quesadilla (Chicken)" },
  { src: IMAGES.fajitaPasta, label: "Smoked Fajita Pasta" },
  { src: IMAGES.tenders, label: "Golden Crunch Tenders" },
  { src: IMAGES.alpineBurger, label: "Alpine Swiss Burger" },
  { src: IMAGES.bakedPasta, label: "Cheezy Bakeblust Pasta" },
  { src: IMAGES.madFuego, label: "Mad Fuego Pasta", w: "tall" },
  { src: IMAGES.birriaPoutine, label: "Birria Poutine" },
  { src: IMAGES.phillyPoutine, label: "Philly Steak Poutine" },
  { src: IMAGES.classicOG, label: "Classic OG Cheez" },
  { src: IMAGES.coleslawChicken, label: "Coleslaw Chicken Burger", w: "tall" },
];

// Real Google reviews (verbatim, trimmed) — do not fabricate
export const REVIEWS = [
  { name: "Asad Sumair", tag: "Local Guide · 129 reviews", rating: 5, text: "We tried their tacos, especially the birria tacos, and they were amazing. The meat was very flavorful, juicy, and cooked perfectly. What really stood out was the birria consommé." },
  { name: "Urooj Danish", tag: "Winnipeg", rating: 5, text: "By far the best halal burger in Winnipeg. The best buck for your money. The portions were very satisfying and he even offered a complimentary drink." },
  { name: "Raahil Qureshi", tag: "Delivery · Dinner", rating: 5, text: "I ordered the Smokey Meat Stack Combo — the sandwich was absolutely delicious! The beef was tender and juicy, the sauce was amazing. Definitely my new go-to spot!" },
  { name: "cc02", tag: "Visiting from Edmonton", rating: 5, text: "Looking for a late-night spot for a good bite, I stumbled upon Smokey & Creamy. Food came out quick and piping hot. The Tres Tacos were super flavourful." },
  { name: "Mlwsp24", tag: "Take Out", rating: 5, text: "Get the ALPINE BURGER! It is the best burger in Winnipeg in my opinion. Excellent seasoning on the ground beef, a fresh delicious bun and a great portion size." },
  { name: "Sayeed Chowdhury", tag: "Take Out", rating: 5, text: "Affordable but top-notch quality food. We ordered Pasta Fajita, chicken fingers and poutine — must try them all. Their smokey sauce sure has a good kick." },
  { name: "Tahidur Rahman", tag: "Dinner", rating: 5, text: "I tried the Alpine Swiss Burger and it was honestly a great experience. Perfectly cooked, juicy and full of flavour — the cheese paired really well with the patty. Looking forward to coming back." },
  { name: "Beverly Juco", tag: "11 reviews · 5 photos", rating: 5, text: "I had the Prairie Gold Poutine. It is the best poutine I've had by far!" },
  { name: "Michael Chandler", tag: "Regular", rating: 5, text: "I've tried so many pastas in so many places, but nobody can beat their pasta. Their chicken fingers are amazing too with their secret spices." },
  { name: "AH H", tag: "Local Guide · 139 reviews", rating: 5, text: "Smokey & Creamy has quickly become one of my favourite spots. The service was exceptional — the attendant greeted me warmly and the Tres Tacos were incredible." },
  { name: "Turjo", tag: "Dinner", rating: 5, text: "Tried this new halal restaurant and I'm in love. The jalapeño burger portion was huge and the taste was so damn good. Customer service was top notch." },
  { name: "Rahmi Safa", tag: "Take Out", rating: 5, text: "I love how filling and hearty their portions are! Such a well thought-out menu and the food is to die for. You don't want to miss out on this spot." },
];

export const NAV = [
  { label: "Menu", href: "#menu" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Visit", href: "#visit" },
];
